import {
  PRODUCT_CATEGORY_STATUS_MESSAGES,
  ProductCategoryStatusMessages,
} from "./product-categories-status.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";

export type ProductCategoryFormMessages = ActionButtonMessages &
  ProductCategoryStatusMessages & {
    // Labels
    codeLabel: string;
    descriptionLabel: string;
    parentCodeLabel: string;

    // Title
    descriptionCardTitle: string;
    editVariationTitle: string;
    newVariationTitle: string;

    // Options
    noParentCodeOption: string;

    // Error messages
    errorRequiredCategoryCode: string;
    errorRequiredCategoryDescription: string;
    errorParentCodeCannotBeSameAsCode: string;
  };

export const PRODUCT_CATEGORY_FORM_MESSAGES: ProductCategoryFormMessages = {
  // Labels
  codeLabel: "Código",
  descriptionLabel: "Nome",
  parentCodeLabel: "Código do pai",

  // Title
  descriptionCardTitle: "Descrição da Categoria",
  editVariationTitle: "Editar Variação",
  newVariationTitle: "Nova Variação",

  // Options
  noParentCodeOption: "Nenhum (Tornar Raiz)",

  // Error messages
  errorRequiredCategoryCode: "O código da categoria é obrigatório!",
  errorRequiredCategoryDescription: "O nome da categoria é obrigatório!",
  errorParentCodeCannotBeSameAsCode:
    "O código da categoria pai não pode ser o mesmo que o código da categoria!",

  ...PRODUCT_CATEGORY_STATUS_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
